import "core-js/modules/es.error.cause.js";
import { request } from './utils';

const requestSchema = (url, {
  query,
  method = "POST"
} = {}) => {
  return request({
    url,
    body: query,
    method
  }).then(res => {
    if (res.success === true) {
      return res;
    }

    throw new Error('查询方案请求：返回状态不对');
  }).catch(e => {
    console.error(e);
    throw e;
  });
};
/**
 * 获取搜索方案列表
 */


export const fetchSchemas = (url, query) => {
  return requestSchema(url, {
    query
  }).then(res => {
    return res.data;
  }).catch(e => {
    return [];
  });
};
/**
 * 保存方案
 */

export const saveSchema = (url, query) => {
  return requestSchema(url, {
    query
  }).then(res => {
    return res;
  }).catch(e => {
    return {
      success: false
    };
  });
};
/**
 * 删除方案
 */

export const deleteSchema = (url, query) => {
  return requestSchema(url, {
    query
  }).then(res => {
    return res;
  }).catch(e => {
    return {
      success: false
    };
  });
};